/* RESPONSIBLE TEAM: team-app-security */
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default EmbercomBaseSerializer.extend(EmbeddedRecordsMixin, {
  attrs: {
    members: {
      serialize: 'records',
      deserialize: 'records',
    },
    role: {
      deserialize: 'records',
      serialize: 'ids',
    },
  },

  keyForAttribute(attr) {
    return attr;
  },
});
